// extracted by mini-css-extract-plugin
export default {"topPanel":"TopPanel_topPanel__CStSj","currentPage":"TopPanel_currentPage__e5+Bi","hint":"TopPanel_hint__cguuU","descr":"TopPanel_descr__4piOX"};